import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Assuming a custom log function similar to FlutterFlow

const stripeSubscriptionManager = async (
  producttype,
  engagement,
  trial_days = 0,
  forever_plan = null,
  token,
  prefix
) => {
  // Define the endpoint URL
  const url = prefix + "stripe/manage-plan";
  // Define the request body
  const body = {
    engagement: engagement,
    product_type: producttype,
    trial_days: trial_days,
    forever_plan: forever_plan,
  };

  // Define headers
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    // Make the POST request
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body), // Encode the body as JSON
    });

    const responseText = await response.text();

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      return "User not logged in";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));

    if (!userSnapshot.exists()) {
      console.error("User document not found");
      return;
    }

    const org_id = userSnapshot.get("org_id");

    // Add log document
    await addLogDocument(
      url,
      prefix,
      userRef, // Only log the userRef ID
      org_id,
      response.status.toString(),
      "", // folderid
      "", // docid
      JSON.stringify(body), // request body as string
      responseText
    );

    // Check if the request was successful
    if (response.ok) {
      const mapp = JSON.parse(responseText);
      const url = mapp.url || "done";
      return url; // Handle successful response
    } else {
      // Handle error response
      console.error(`Failed to create user: ${response.status}`);
      return "";
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return "";
  }
};

export default stripeSubscriptionManager;
